import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGameBarbarianInvasionProgressTrackerView} from './UIGameBarbarianInvasionProgressTrackerView'
import {UIGamePlayerInformationDefenderOfColonistView} from '../ui_game_players/UIGamePlayerInformationDefenderOfColonistView'
import {UIGamePlayerInformationView} from '../ui_game_players/UIGamePlayerInformationView'
import {MechanicBarbarianInvasionState, MechanicKnightState} from '@colonist/game-states'

export abstract class UIGameBarbarianInvasion implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    protected readonly barbarianInvasionState: MechanicBarbarianInvasionState
    protected readonly knightState: MechanicKnightState
    protected barbarianInvasionTrackerView: UIGameBarbarianInvasionProgressTrackerView
    private playerInformationDefenderOfColonistViews: UIGamePlayerInformationDefenderOfColonistView[]

    constructor(uiGameManager: UIGameManager, barbarianInvasionState: MechanicBarbarianInvasionState, knightState: MechanicKnightState) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.barbarianInvasionState = barbarianInvasionState
        this.knightState = knightState

        this.barbarianInvasionTrackerView = new UIGameBarbarianInvasionProgressTrackerView(this.uiGameManager, this.barbarianInvasionState, this.knightState)
        this.barbarianInvasionTrackerView.updateProgressTracker()
        this.playerInformationDefenderOfColonistViews = []
        this.initPlayerInformationDefenderOfColonistViews()
    }

    protected abstract createDefenderOfColonistView(playerInformation: UIGamePlayerInformationView): UIGamePlayerInformationDefenderOfColonistView

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.MapStateUpdated:
            case UIGameEventEnums.KnightStateUpdated:
            case UIGameEventEnums.BarbarianInvasionStateUpdated: this.barbarianInvasionTrackerView.updateProgressTracker(); break
            case UIGameEventEnums.CanvasResized: this.onCanvasResize(); break
            default: break
        }
    }

    private onCanvasResize() {
        this.initPlayerInformationDefenderOfColonistViews()
        this.barbarianInvasionTrackerView.destroy()
        this.barbarianInvasionTrackerView = new UIGameBarbarianInvasionProgressTrackerView(this.uiGameManager, this.barbarianInvasionState, this.knightState)
        this.barbarianInvasionTrackerView.updateProgressTracker()
    }

    private initPlayerInformationDefenderOfColonistViews() {
        this.playerInformationDefenderOfColonistViews.forEach((view) => view.destroy())
        this.playerInformationDefenderOfColonistViews = []

        for(const playerInformation of this.uiGameManager.playersController.playerInformationViews) {
            const newPlayerInformationDefenderOfColonistView = this.createDefenderOfColonistView(playerInformation)
            this.playerInformationDefenderOfColonistViews.push(newPlayerInformationDefenderOfColonistView)
        }
    }
}
